module.exports = __webpack_public_path__ + "images/guardias.ca710c21bb10464e80818c38ab2088ed.png";